<template>
  <div class="progress-bar" :title="progressTitle">
    <div
      class="progress-bar__completed"
      :style="{width: `${progress * 100}%`}"
    />
  </div>

</template>

<script>
  export default {
    name: "ProgressBar",
    props: {
      progress: Number
    },
    methods: {
      setProgress(progress) {
        this.progress = progress > 1 ? 1 : progress;
      },
    },
    computed: {
      progressTitle() {
        return `${parseInt(this.progress * 100)}%`;
      },
    }
  }
</script>
